import { oz } from '@weft/utils';

export const UploadMeasurementsResponseSchema = oz.object({
  message: oz.string(),
}).openapi('UploadMeasurementsResponse');

export type UploadMeasurementsResponse = oz.infer<typeof UploadMeasurementsResponseSchema>;